const state = {
  services: {}
};

export default {
  state
};
